<template>
  <b-table
    id="material-table"
    :fields="fields"
    :items="GET_APPLICATIONS_GOOD_RETURN.results"
    show-empty
    responsive
    hover
    :empty-text="$t('empty_text')"
    @row-clicked="$emit('row-selected', $event)"
  >
    <template #head()="props">
      <span>{{ $t(props.label) }}</span>
    </template>
    <!-- <template #cell(category)="{ item }">
      <span v-if="item.product.category && item.product.category.title">
        {{ item.product.category.title }}
      </span>
    </template>
    <template #cell(character)="{ item }">
      {{ item.product.character }}
    </template>
    <template #cell(value)="{ item }">
      {{ item.value }}
    </template>
    <template #cell(unity)="{ item }">
      {{ item.unity }}
    </template>
    <template #cell(total_count)="{ item }">
      {{ $_formatPriceMixin(item.total_count) }}
    </template> -->
    <!-- <template #cell(remainder)="{value}">
      <template v-if="value.length">
        <div
          v-for="(item, index) in value"
          :key="index"
        >
          <span>{{ item.storage__title }}</span> - <span>{{ item.sum_remainder }}</span>
        </div>
      </template>
      <template v-else>
        <span>0</span>
      </template>
    </template> -->

    <template #cell(actions)="{ item }">
      <div>
        <b-button
          v-for="(but, index) in item.status.change_to"
          :key="index"
          variant="outline-success"
          size="sm"
          class="mt-50 mb-50"
          @click="confirm(item, but)"
        >
          {{$t('confirm2')}}
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script>
import { BButton, BTable } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import priceFormatMixin from "@/mixins/priceFormatMixin.js";

export default {
  components: {
    BTable,
    BButton,
  },
  mixins: [priceFormatMixin],
  data: () => ({
    fields: [
      {
        label: "№",
        key: "id",
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
      {
        label: "courses.type",
        key: "good.product.title",
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
      {
        label: "product",
        key: "good.value",
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
      {
        label: "object",
        key: "author.rc_object",
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
      {
        label: "unit_of_measurement",
        key: "good.unity",
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
      {
        label: "amount",
        key: "quantity",
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
      {
        label: "date",
        key: "created_at",
        formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
      {
        label: "master",
        key: "author.first_name",
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
      // {
      //   label: "ПРИМЕЧАНИЕ",
      //   key: "material.note",
      //   thClass: "tableHeadClass",
      //   tdClass: "text-center",
      // },
      {
        label: "actions",
        key: "actions",
        thClass: "tableHeadClass",
        tdClass: "text-center",
      },
    ],
  }),
  computed: {
    ...mapGetters("application", [
      "GET_APPLICATIONS_GOOD_RETURN",
      "GET_APPLICATIONS_INSTRUMENT_RETURN",
    ]),
  },
  methods: {
    ...mapActions("application", [
      "EDIT_FOR_GOOD_RETURN",
      "FETCH_APPLICATION_INSTRUMENT_RETURN",
      "FETCH_APPLICATION_GOOD_RETURN",
    ]),
    confirm(data, item) {
      const status = {
        accepted_return_off: this.$t('confirm2'),
        confirmed: this.$t('confirm_this_application'),
        denied: this.$t('refuse_this_application'),
        closed: this.$t('close_this_application'),
      };
      this.$bvModal
        .msgBoxConfirm(
          this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
          {
            title: this.$i18n.t('attention'),
            size: "sm",
            okVariant: item.color,
            okTitle: this.$t('yes'),
            cancelTitle: this.$t('no'),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (!value) return;
          this.EDIT_FOR_GOOD_RETURN({
            data: { status_unique: item.unique_name },
            id: data.id,
          }).then(() => {
            this.$_okToast();
            this.$emit("refresh");
          });
        });
    },
  },
};
</script>

<style lang='scss'>
</style>
